/* @flow */

export const LOG_LEVEL = {
    DEBUG: ('debug' : 'debug'),
    INFO:  ('info' : 'info'),
    WARN:  ('warn' : 'warn'),
    ERROR: ('error' : 'error')
};



// WEBPACK FOOTER //
// ./src/constants.js